import axios from 'axios';

export const server = 'https://apaskideal.mangotech-api.com/';

const instance = axios.create({
  baseURL: server,
});

export default instance;